import { useContext } from 'react';
import * as React from 'react';
import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { ApolloProvider } from '@apollo/client/react';
import { setContext } from '@apollo/client/link/context';

import { AppConfig } from '../../config';

const cache = new InMemoryCache();

interface IProps {
  children?: React.ReactNode;
}
export const ApolloConfigProvider = ({ children }: IProps) => {
  const { apiUrl, userInfo } = useContext(AppConfig);

  const httpLink = createHttpLink({
    uri: apiUrl,
    credentials: 'include',
  });

  const authLink = setContext((_, prevContext) => {
    const token = userInfo ? userInfo.token : '';
    const headers = (prevContext.headers ?? {}) as Record<string, string>;

    return {
      headers: {
        ...headers,
        Authorization: token,
      },
    };
  });

  const client = new ApolloClient({
    link: authLink.concat(httpLink),
    cache,
  });

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
